function ContainerLarge ({ className, children }) {
    return (
        <div className={`max-w-lg mx-auto ${className || ''}`}>
            { children }
        </div>
    );
}

export default ContainerLarge;